export default __webpack_public_path__ + "static/media/Z2CBronzeBadge1stWeek.7d189a5d.png";